import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import { Order, OrderFilterFields, OrderMainSearchFields } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const mainSearchConfig: Order.Search.Config = {
	[OrderMainSearchFields.id]: {
		label: i18n.t('pages:order.filters.orderId'),
		apiFieldName: OrderMainSearchFields.id,
		apiSearchFieldName: 'orderId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id
	},
	[OrderMainSearchFields.itemName]: {
		label: i18n.t('pages:order.filters.itemName'),
		apiFieldName: OrderMainSearchFields.itemName,
		apiSearchFieldName: 'itemName',
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.itemName
	},
	[OrderMainSearchFields.itemId]: {
		label: i18n.t('pages:order.filters.itemId'),
		apiFieldName: OrderMainSearchFields.itemId,
		apiSearchFieldName: 'itemId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.itemId
	}
}

export const getFiltersConfig = (isSmallScreen: boolean): Order.Filter.Config => ({
	[OrderFilterFields.startDate]: {
		label: i18n.t('pages:order.filters.serviceDateFrom'),
		apiFilterFieldName: 'DateFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[OrderFilterFields.endDate]: {
		label: isSmallScreen
			? i18n.t('pages:order.filters.serviceDateTo')
			: i18n.t('pages:order.filters.to'),
		apiFilterFieldName: 'DateTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[OrderFilterFields.status]: {
		label: i18n.t('pages:order.filters.status'),
		apiFilterFieldName: 'statusId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.statusId,
		defaultValue: ''
	},
	[OrderFilterFields.serviceSite]: {
		label: i18n.t('pages:order.filters.serviceSite'),
		apiFilterFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	}
})
